import React, { createContext, useCallback, useContext, useEffect, useMemo } from 'react';

const ENTERPRISE_THEME = 'enterprise';
const ThemeContext = createContext(null);

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) throw new Error('useTheme must be used within ThemeProvider');
  return context;
};

/**
 * The CRM intentionally ships one audited enterprise theme. The compatibility
 * methods remain stable because AuthContext and older components call them.
 */
export const ThemeProvider = ({ children }) => {
  useEffect(() => {
    document.documentElement.setAttribute('data-theme', ENTERPRISE_THEME);
    document.documentElement.style.colorScheme = 'light';
  }, []);

  const setTheme = useCallback(() => ENTERPRISE_THEME, []);
  const initThemeFromUser = useCallback(() => ENTERPRISE_THEME, []);

  const value = useMemo(
    () => ({
      theme: ENTERPRISE_THEME,
      dark: false,
      setTheme,
      initThemeFromUser,
    }),
    [setTheme, initThemeFromUser],
  );

  return <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>;
};
